module.exports = __webpack_public_path__ + "static/media/star_icon.04b1bc36.png";